import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { IUserFormInput, IUserUpdateProps } from "./User.model";
import { userService } from "../../service/User/user.service";
import UserForm from "./_userForm";

const UserUpdate = ({ data, setUserDialog, loadUsers }: IUserUpdateProps) => {
  const [id, setId] = useState<number | null>(null);

  const methods = useForm<IUserFormInput>({
    defaultValues: {
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      is_active: true,
      is_staff: false,
      is_superuser: false,
      password: "",
      group_id: null,
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        username: data.username,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        is_active: data.is_active,
        is_staff: data.is_staff,
        is_superuser: data.is_superuser,
        password: "",
        group_id: data.group ? data.group.id : null,
      });
    }
  }, [data]);

  const onSubmit = async (values: IUserFormInput) => {
    if (!id) return;

    // Do not send empty password
    const payload = { ...values };
    if (!payload.password) delete payload.password;

    const response = await userService.update(id, payload);

    if (response.success) {
      loadUsers();
      setUserDialog(false);
    } else {
      Object.keys(response.errors || {}).forEach((field) => {
        methods.setError(field as any, {
          type: "manual",
          message: response.errors[field],
        });
      });
    }
  };

  return <UserForm methods={methods} onSubmit={onSubmit} isEdit={true} />;
};

export default UserUpdate;
